/* eslint-disable quotes */
/* eslint-disable no-multi-spaces */
import React, { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  FormHelperText,
  Typography,
  FormControl,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CustomToolbar from "./customToolBar";
import CustomToolTip from "../Tooltip/CustomToolTip";
import i18n from "../../i18n";
import { getDateLocale } from "../../utils/date";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  minWidth: "100%",
}));

export default function DatePicker(props) {
  const {
    name,
    label,
    showTooltip,
    format = "MM/dd/yyyy",
    onChange,
    variant = "outlined",
    required,
    maxDate,
    minDate,
    value,
    error = null,
    disableFuture = false,
    id,
    disabled = false,
    openPickerButton,
    ...others
  } = props;

  const [open, setOpen] = useState(false);

  const handleInputClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <StyledFormControl variant={variant} id={id} error={!!error}>
      {label && (
        <Typography
          component="p"
          className={required ? "inputLabel required" : "inputLabel"}
        >
          {label}
          {showTooltip && (
            <CustomToolTip
              title={i18n.t("common.labels.infoTextShipmentDate")}
            />
          )}
        </Typography>
      )}
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getDateLocale()}>
        <MuiDatePicker
          open={disabled ? false : open}
          onClose={handleClose}
          format={format}
          name={name}
          value={value}
          onChange={(date) => {
            onChange(name, date);
          }}
          onAccept={(date) => {
            onChange(name, date);
            handleClose();
          }}
          views={['year', 'month', 'day']}
          disableFuture={disableFuture}
          maxDate={maxDate}
          minDate={minDate}
          desktopModeMediaQuery="@media (min-width:900px)"
          slots={{
            textField: TextField,
            toolbar: (toolbarProps) => <CustomToolbar {...toolbarProps} />,
          }}
          disabled={disabled}
          slotProps={{
            textField: {
              variant: "outlined",
              size: "small",
              error: !!error,
              onClick: handleInputClick,
              placeholder: " ",
              onKeyDown: (e) => e.preventDefault(),
              ...others,
              inputProps: {
                ...others?.inputProps,
                onDragOver: (e) => e.preventDefault(),
                onDrop: (e) => e.preventDefault(),
              },
            },
            openPickerButton: openPickerButton ?? {},
          }}
          showToolbar={true}
        />
      </LocalizationProvider>
      {error && <FormHelperText>{error}</FormHelperText>}
    </StyledFormControl>
  );
}
